exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".view-error500 .ernie{z-index:20;position:absolute;bottom:-20px;right:114px;width:168px;height:143px;background:url(" + require("public/images/ernie/untangling-wires.png") + ")}.view-error500 .error-message{padding-bottom:150px}", ""]);

// exports
